import React from "react";
import { H3 } from "@/common/ui/Text";

interface PaymentTabsProps {
  activeTab: "incoming" | "outgoing";
  onTabChange: (tab: "incoming" | "outgoing") => void;
  className?: string;
  canViewIncoming?: boolean;
  canViewOutgoing?: boolean;
}

const PaymentTabs: React.FC<PaymentTabsProps> = ({ 
  activeTab, 
  onTabChange, 
  className = "", 
  canViewIncoming = true, 
  // canViewOutgoing = true 
}) => {
  const tabs = [
    { key: "incoming" as const, label: "Incoming payments", canView: canViewIncoming },
    // { key: "outgoing" as const, label: "Outgoing payments", canView: canViewOutgoing },
  ].filter(tab => tab.canView);


  return (
    <div className={`${className}`}>
      <div className="flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`pb-1 px-1 border-b-2 transition-colors duration-200 ${
              activeTab === tab.key
                ? "border-text-primary text-text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            <H3 text={tab.label} className={`text-[13px] ${
              activeTab == tab.key
                ? '!text-[#7a45bc] font-[700] ' : '!text-[#495057] !font-[400]'}`} />
          </button>
        )
        )}
      </div>
    </div>
  );
};

export default PaymentTabs;

